<template>
  <div>
    <div>
      <div class="input-group mb-3">
        <div class="input-group-prepend">
          <span class="input-group-text">Search</span>
        </div>
        <input type="text" class="form-control" v-model="search" @input="filterData">
      </div>
    </div>

    <div>
      <div class="input-group mb-3">
        <div class="input-group-prepend">
          <span class="input-group-text">Sort by</span>
        </div>
        <select v-model="sortBy" @change="sort">
          <option v-for="(title,index) in headers" :key="index" :value="index">{{ title.toUpperCase() }}</option>
        </select>
        <div class="input-group-append">
          <select v-model="order" @change="sort">
          <option value="asc">ASC</option>
          <option value="desc">DESC</option>
        </select>
        </div>
      </div>
    </div>

    
    <div class="btn-group btn-group-justified w-100">
      <button @click="prev" class="btn btn-outline-info"><i class="fa fa-angle-double-left"></i></button>
      <button @click="downloadCSVData" class="btn btn-outline-primary btn-block">Download</button>
      <button @click="next" class="btn btn-outline-info"><i class="fa fa-angle-double-right"></i></button>
    </div>

    <div class="row">
      <div class="col col-xs-12">
        <p class="m-2">Showing {{start+1}} to {{end}} of {{filteredData.length}} entries</p>
      </div>
      <div class="col col-xs-12">
        <p class="m-2">Show <input type="number" v-model="entries" @input="changeEntries" /> entries </p>
      </div>
    </div>

    <table class="table table-striped mb-5 table-bordered">
      <thead>
        <tr>
          <th>Sl.No</th>
          <th v-for="(title,index) in headers" :key="index">{{ title.charAt(0).toUpperCase() + title.slice(1) }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row,index) in filteredData.slice(start, end)" :key="index">
          <td>{{start+index+1}}</td>
          <td v-for="(title,ind) in headers.slice(0,-1)" :key="ind">{{ row[title] }}</td>
          <td>{{timestamp_to_date(row['joinedAt'])}}</td>
        </tr>
      </tbody>
    </table>
    
  </div>
</template>

<style>
table {
    display: block;
    overflow-x: auto;
    white-space: nowrap;
}
</style>

<script type="text/javascript">
export default {
  name: 'SubscribersTable',
  props:{
    data: Array,
    headers: Array
  },
  data() {
    return {
      start: 0,
      end: 10,
      entries: 10,
      search: '',
      filteredData: this.data,
      sortBy: 0,
      order: 'asc'
    }
  },
  methods: {
    downloadCSVData(){
      let csv = 'Sl.No, User, ' + this.headers.join(', ') + '\n';
      let index = 0;
      this.filteredData.forEach((row) => {
        index = index + 1;
        csv +=  index+ ', ' + row.id + ', ' + this.headers.map((header) => row[header]).join(', ') + '\n';
      });
  
      const anchor = document.createElement('a');
      anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
      anchor.target = '_blank';
      anchor.download = 'Bot_creator_subscribers.csv';
      anchor.click();
    },
    next(){
      if(this.end < this.filteredData.length){
        this.start = this.start + parseInt(this.entries);
        this.end = this.end + parseInt(this.entries);
        if(this.end>this.filteredData.length){
          this.end = this.filteredData.length;
        }
      }
    },
    prev(){
      if (this.start >= parseInt(this.entries)) {
        this.start = this.start - parseInt(this.entries);
        this.end = this.start + parseInt(this.entries);
      }else{
        this.start = 0
        this.end = parseInt(this.entries)
      }
      if(this.end>this.filteredData.length){
          this.end = this.filteredData.length;
      }
    },
    filterData(){
      if(this.search === ''){
        this.filteredData = this.data;
      }else{
        this.filteredData = this.data.filter((row) => {
          return this.headers.some((key) => {
            if(this.timestamp_to_date(row.joinedAt).toString().toLowerCase().includes(this.search.toLowerCase())){
              return true;
            }
            if(key in row && row[key] != null){
              return row[key].toString().toLowerCase().includes(this.search.toLowerCase());
            }else{
              return false;
            }
          });
        });
      }
      this.start = 0;
      let end = parseInt(this.entries);
      if(end>this.filteredData.length){
        this.end = this.filteredData.length;
      }else{
        this.end = end;
      }
    },
    changeEntries(){
      let end = this.start + parseInt(this.entries)
      if(end>this.filteredData.length){
        this.end = this.filteredData.length;
      }else{
        this.end = end;
      }
    },
    sort(){
      //sort data by sortBy in order of asc or desc
      this.filteredData.sort((a,b) => {
        if(a[this.headers[this.sortBy]] == undefined || a[this.headers[this.sortBy]] == null){
            a[this.headers[this.sortBy]] = '';
        }
        if(b[this.headers[this.sortBy]] == undefined || b[this.headers[this.sortBy]] == null){
            b[this.headers[this.sortBy]] = '';
        }
        if(this.order === 'asc'){
          return a[this.headers[this.sortBy]] > b[this.headers[this.sortBy]] ? 1 : -1;
        }else{
          return a[this.headers[this.sortBy]] < b[this.headers[this.sortBy]] ? 1 : -1;
        }
      });
    },
    timestamp_to_date(timestamp){
      timestamp = timestamp * 1000;
      let date = new Date(timestamp);
      let date_time = date.getDate() + '/' + (date.getMonth()+1) + '/' + date.getFullYear() + ' ' + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds();
      return date_time;
    }
  },
  watch: {
    data(){
      this.filteredData = this.data;
    }
  }
}

</script>
